import * as api from '@/api/navigation'
import NavItem from '@/store/models/navItem'

export let state = {
  navItem: new NavItem,
  navItems: {
    data: []
  }
}

export let mutations = {
  setNavItems: (state, payload) => state.navItems = payload,

  reset: state => state.navItem = new NavItem,
  setNavItem: (state, payload) => state.navItem = (new NavItem).hydrate(payload),
  setTitle: (state, payload) => state.navItem.title = payload,
  setActive: (state, payload) => state.navItem.active = payload,
  setPageId: (state, payload) => state.navItem.page_id = payload,
  setParentId: (state, payload) => state.navItem.parent_id = payload,
}

export let actions = {

  paginate: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginate(path, response => {
      commit('setNavItems', response.data)
      resolve()
    }, reject)
  }),

  load: ({ commit }, navItem) => new Promise((resolve, reject) => {
    api.load(navItem, response => {
      commit('setNavItem', response.data)
      resolve()
    }, reject)
  }),

  create: ({ state, commit }, parent = '') => new Promise((resolve, reject) => {
    api.create(state.navItem, parent, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  save: ({ state, commit }) => new Promise((resolve, reject) => {
    api.save(state.navItem, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  remove: ({ }, navItem) => new Promise((resolve, reject) => {
    api.remove(navItem.id, resolve, reject)
  })
  
}